var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Table',{on:{"select":_vm.select}})],1),_c('DeviceDetail',{ref:"detail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }